export default __webpack_public_path__ + "static/media/2018-1.ae18d116.jpg";